import { useAuth as useFronteggAuth, useEntitlementsActions, useLoginWithRedirect, useLoginWithRedirectV2, } from "@frontegg/react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FronteggConfigContext } from "../providers/AuthProvider";
export function useAuth(isEmployeeLogin = false) {
    const fronteggAuthState = useFronteggAuth();
    const entitlementsActions = useEntitlementsActions();
    const loginEmployee = useLoginWithRedirect();
    const loginCustomer = useLoginWithRedirectV2();
    const fronteggConfig = useContext(FronteggConfigContext);
    if (!fronteggConfig) {
        throw new Error("Frontegg config is missing");
    }
    useEffect(() => {
        if (fronteggConfig && !fronteggAuthState.isAuthenticated) {
            localStorage.setItem("_REDIRECT_AFTER_LOGIN_", window.location.pathname);
            if (isEmployeeLogin) {
                loginEmployee({ organization: fronteggConfig.internalOrganizationId });
            }
            else {
                loginCustomer({
                    additionalParams: undefined,
                    shouldRedirectToLogin: true,
                    firstTime: false,
                    loginDirectAction: {
                        type: "custom-social-login",
                        data: fronteggConfig.customSocialLoginId,
                    },
                });
            }
        }
    }, [isEmployeeLogin, fronteggAuthState, loginEmployee, fronteggConfig, loginCustomer]);
    const navigate = useNavigate();
    useEffect(() => {
        const originalRoute = localStorage.getItem("_REDIRECT_AFTER_LOGIN_");
        if (fronteggAuthState.isAuthenticated && originalRoute !== null) {
            localStorage.removeItem("_REDIRECT_AFTER_LOGIN_");
            navigate(originalRoute);
        }
    }, [fronteggAuthState.isAuthenticated]);
    const mapUser = (userFromFrontegg) => {
        const { id, name, email, tenantId, accessToken, metadata } = userFromFrontegg;
        const locale = JSON.parse(metadata)?.locale ?? null;
        return {
            id,
            name,
            email,
            organizationSlug: tenantId,
            accessToken,
            locale,
        };
    };
    return {
        user: fronteggAuthState.user ? mapUser(fronteggAuthState.user) : null,
        isAuthenticated: fronteggAuthState.isAuthenticated,
        hasPermission: (permissionKey) => entitlementsActions.isEntitledTo({ permissionKey }).isEntitled,
        logout: (postLogoutRedirectUri) => {
            const config = {
                baseUrl: fronteggConfig.baseUrl,
                keycloakUrl: fronteggConfig.keycloakUrl,
                postLogoutRedirectUri,
            };
            window.location.href = buildLogoutUrl(config);
        },
    };
}
const buildLogoutUrl = (config) => {
    const { baseUrl, keycloakUrl, postLogoutRedirectUri } = config;
    const postLogoutUrlVarName = "post_logout_redirect_uri";
    const logoutUrl = new URL(`${baseUrl}/oauth/logout`);
    const keycloakLogoutUrl = new URL(`${keycloakUrl}/auth/realms/climatepartner/protocol/openid-connect/logout`);
    keycloakLogoutUrl.searchParams.set(postLogoutUrlVarName, postLogoutRedirectUri);
    logoutUrl.searchParams.set(postLogoutUrlVarName, keycloakLogoutUrl.toString());
    return logoutUrl.toString();
};
//# sourceMappingURL=useAuth.js.map